export default "__VITE_ASSET__JH$ZfgWR__"